import B2ChatClient from '@src/client';
import { fetchChatTotalsSuccess } from '@src/reducers/chats';
import { ChatsFilters } from '@src/reducers/chatSearch';
import {
  selectIsChatSideInitiated,
  selectTotalChatsSide,
} from '@src/selectors/chats';
import { B2ChatAPI } from '@src/types/api';
import {
  ChatSidesTotals,
  ChatSideType,
  ChatTotalsResponse,
} from '@src/types/chats';
import { omitEmptyParams } from '@src/utils/objectUtils';
import { all, call, put, select } from 'redux-saga/effects';

export function* fetchChatSideTotalsSaga(
  chatSide: ChatSideType,
  filters?: ChatsFilters
) {
  try {
    const response: ChatTotalsResponse = yield call(
      startFetchSingleChatTotalsSaga,
      chatSide,
      filters
    );

    const chatSidesTotals: ChatSidesTotals = {} as ChatSidesTotals;

    if (response && 'totalChats' in response) {
      const isChatSideInitiated: boolean = yield select(
        selectIsChatSideInitiated(chatSide)
      );

      chatSidesTotals[chatSide] = response;

      if (isChatSideInitiated) {
        const totalChatsSide: number = yield select(
          selectTotalChatsSide(chatSide)
        );

        chatSidesTotals[chatSide].totalChats = totalChatsSide;
        chatSidesTotals[chatSide].totalFilteredChats = response.totalChats;
      }

      yield put(fetchChatTotalsSuccess(chatSidesTotals));
    }
    // eslint-disable-next-line no-empty
  } catch (error) {}
}

export function* fetchChatTotalsSaga() {
  try {
    const [onHoldResponse, requestResponse, botResponse]: ChatTotalsResponse[] =
      yield all([
        call(startFetchSingleChatTotalsSaga, ChatSideType.ON_HOLD),
        call(startFetchSingleChatTotalsSaga, ChatSideType.REQUEST),
        call(startFetchSingleChatTotalsSaga, ChatSideType.BOT),
      ]);

    const chatSidesTotals: ChatSidesTotals = {} as ChatSidesTotals;

    if ('totalChats' in onHoldResponse)
      chatSidesTotals[ChatSideType.ON_HOLD] = onHoldResponse;

    if ('totalChats' in requestResponse)
      chatSidesTotals[ChatSideType.REQUEST] = requestResponse;

    if ('totalChats' in botResponse)
      chatSidesTotals[ChatSideType.BOT] = botResponse;

    yield put(fetchChatTotalsSuccess(chatSidesTotals));
    // eslint-disable-next-line no-empty
  } catch (error) {}
}

function* startFetchSingleChatTotalsSaga(
  sideType: ChatSideType,
  filtersPayload: ChatsFilters = {} as ChatsFilters
) {
  const { error, data }: B2ChatAPI.Response<ChatTotalsResponse> = yield call(
    B2ChatClient.resources.agentConsole.actions.getChatsAndCallsCount,
    {
      params: omitEmptyParams({
        ...filtersPayload,
        type: sideType,
      }),
    }
  );

  if (error)
    return {
      type: sideType,
      error: true,
      message: error.message,
    };

  return data;
}
